import React, {useState} from "react";
import {LoadingSpinner} from "../../ui/LoadingSpinner";
import {Table} from "react-bootstrap";
import {IconButton} from "@mui/material";
import PlaylistPlayIcon from '@mui/icons-material/PlaylistPlay';
import {TooltipWithCopy} from "../../ui/TooltipWithCopy";
import {MachineDetail} from "../../pages/machines/MachineDetail";
import {MachineErrors_Archive} from "../../pages/machines/MachineErrors_Archive";


export const InnerUsersList = ({usersData, isLoading}) => {

    const [showMachineModal, setShowMachineModal] = useState(false);
    const [machineToShowUniqueId, setMachineToShowUniqueId] = useState(null);

    const showMachineDetail = (uniqueId) => {
        setMachineToShowUniqueId(uniqueId);
        setShowMachineModal(true);
    }

    const onCloseMachineModal = () => {
        console.log(">> onCloseMachineModal");
        setShowMachineModal(false);
    }

    return (
        <>

            <MachineDetail show={showMachineModal} onClose={onCloseMachineModal}
                           uniqueId={machineToShowUniqueId}/>

            <LoadingSpinner loadingFlag={isLoading}>

                <Table striped bordered hover responsive>
                    <thead>
                    <tr>
                        <th>Username</th>
                        <th>Email</th>
                        <th>Create TS</th>
                        <th>Machines</th>
                    </tr>

                    </thead>
                    <tbody>


                    {usersData &&  usersData.map((user, idx) => (
                        <tr key={idx}>
                            <td><TooltipWithCopy text={user.username} showAsButton={false} small></TooltipWithCopy></td>
                            <td><TooltipWithCopy text={user.email} showAsButton={false}></TooltipWithCopy></td>
                            <td>{user.create_date}</td>
                            <td>
                                {user.machines && user.machines.length > 0 ? (
                                    <Table size="sm" borderless className="mb-0">
                                        <tbody>
                                        {user.machines.map((machine, mIdx) => (
                                            <tr key={mIdx}>
                                                <td>{machine.name || 'Unnamed'}<br/><TooltipWithCopy text={machine.unique_id} showAsButton={false} small/></td>
                                                <td><b>Errors</b><br/><MachineErrors_Archive uniqueId={machine.unique_id}/></td>
                                                <td>
                                                    <IconButton size="small" onClick={() => showMachineDetail(machine.unique_id)}>
                                                        <PlaylistPlayIcon fontSize="small" />
                                                    </IconButton>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </Table>
                                ) : (
                                    <span className="text-muted">No machines</span>
                                )}
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </Table>
            </LoadingSpinner>
        </>
    )
}